import { jsxs as m, jsx as n, Fragment as Z } from "react/jsx-runtime";
import { Close as V, OverlaySpinner as ee, Check as ze, Copy as Me, TextField as ge } from "@ankr.com/ui";
import { Dialog as He, DialogTitle as _e, Box as d, Typography as W, IconButton as O, DialogContent as Ge, alpha as _, Paper as me, Button as $, Collapse as fe, Card as he, Tooltip as Qe, InputAdornment as ye, Popover as Oe, NoSsr as qe, Container as Xe, ListSubheader as Ye, MenuItem as le, InputLabel as Je, Select as Ke, FormHelperText as U } from "@mui/material";
import { makeStyles as C } from "tss-react/mui";
import * as L from "react";
import { memo as ne, useState as G, useCallback as I, useEffect as Q, forwardRef as q, useId as Ue, useMemo as F, useRef as Ze } from "react";
import { useIsMDDown as Ve, useThemeMode as xe } from "@ankr.com/raas-themes";
import { tCommon as B, shallowEqual as be, getLocaleSeparator as de, getErrorMessage as en } from "@ankr.com/raas-utils";
import { Link as te, useNavigate as nn } from "react-router-dom";
import { CopyToClipboard as tn } from "react-copy-to-clipboard";
import rn, { useColorPicker as on } from "react-best-gradient-color-picker";
import { toast as an, ToastContainer as sn } from "react-toastify";
import { injectStyle as cn } from "react-toastify/dist/inject-style";
import { isIOS as ln } from "react-device-detect";
import dn from "react-number-format";
import pn from "bignumber.js";
import { queryFnNotificationWrapper as un } from "@ankr.com/utils/queryFnNotificationWrapper";
const gn = C()((e) => ({
  sideRight: {
    justifyContent: "flex-end"
  },
  titleWrap: {
    display: "flex",
    gap: e.spacing(3),
    justifyContent: "space-between",
    alignItems: "flex-start",
    padding: e.spacing(5, 5, 5)
  },
  titleContent: {
    flexGrow: 1
  },
  title: {},
  titleCentered: {
    textAlign: "center"
  },
  titleCenteredWithButton: {
    marginLeft: e.spacing(13)
  },
  subtitle: {
    color: e.palette.text.secondary
  },
  content: {
    padding: e.spacing(0, 5, 5)
  }
}));
function dt({
  children: e,
  maxWidth: t = "sm",
  withoutCloseButton: r = !1,
  disableCloseOnBackdrop: a = !1,
  title: o,
  subtitle: i,
  onClose: s,
  buttonSize: c = "medium",
  titleClassName: g,
  titleCentered: l,
  sideRight: f,
  ...p
}) {
  const { classes: u, cx: y } = gn();
  return /* @__PURE__ */ m(
    He,
    {
      fullWidth: !0,
      maxWidth: t,
      onClose: a ? () => {
      } : s,
      ...p,
      classes: {
        ...p.classes,
        container: y(p.classes?.container, f && u.sideRight)
      },
      children: [
        (o || !r) && /* @__PURE__ */ m(_e, { className: u.titleWrap, children: [
          /* @__PURE__ */ m(d, { className: u.titleContent, children: [
            o && /* @__PURE__ */ n(
              W,
              {
                variant: "h6",
                component: "div",
                className: y(
                  u.title,
                  l && u.titleCentered,
                  l && !r && u.titleCenteredWithButton,
                  g
                ),
                children: o
              }
            ),
            i && /* @__PURE__ */ n(
              W,
              {
                variant: "body2",
                component: "div",
                className: y(
                  u.subtitle,
                  l && u.titleCentered
                ),
                children: i
              }
            )
          ] }),
          !r && /* @__PURE__ */ n(
            O,
            {
              "aria-label": "close",
              onClick: s,
              color: "inherit",
              size: c,
              children: /* @__PURE__ */ n(V, { sx: { color: "inherit" } })
            }
          )
        ] }),
        /* @__PURE__ */ n(Ge, { className: u.content, children: e })
      ]
    }
  );
}
const Ce = (e) => /* @__PURE__ */ L.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ L.createElement("path", { d: "M16 11L12 15L8 11", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "square", strokeLinejoin: "round" }));
var H = /* @__PURE__ */ ((e) => (e.Asc = "Asc", e.Desc = "Desc", e))(H || {});
const pe = (e) => /* @__PURE__ */ L.createElement("svg", { width: 24, height: 12, viewBox: "0 0 24 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ L.createElement("path", { d: "M16 4L12 8L8 4", stroke: "currentColor", strokeWidth: 1.2, strokeLinecap: "square", strokeLinejoin: "round" })), mn = C()((e) => ({
  root: {
    display: "flex",
    flexDirection: "column"
  },
  icon: {
    cursor: "pointer",
    "&:hover": {
      color: e.palette.primary.main
    }
  },
  up: {
    rotate: "180deg",
    marginBottom: -3
  },
  active: {
    color: e.palette.primary.dark
  }
}));
function fn({ direction: e, onChange: t }) {
  const { cx: r, classes: a } = mn(), o = (i) => {
    t(i === e ? void 0 : i);
  };
  return /* @__PURE__ */ m(d, { className: a.root, children: [
    /* @__PURE__ */ n(
      pe,
      {
        className: r(
          a.icon,
          a.up,
          e === H.Asc && a.active
        ),
        onClick: () => o(H.Asc)
      }
    ),
    /* @__PURE__ */ n(
      pe,
      {
        className: r(
          a.icon,
          e === H.Desc && a.active
        ),
        onClick: () => o(H.Desc)
      }
    )
  ] });
}
function hn({ column: e, className: t }) {
  return /* @__PURE__ */ m(d, { className: t, children: [
    /* @__PURE__ */ n(W, { variant: "body3", children: e.header }),
    e.onSortChange && /* @__PURE__ */ n(fn, { direction: e.sortDirection, onChange: e.onSortChange })
  ] });
}
const yn = ne(hn), re = C()((e) => ({
  root: {
    fontSize: 14,
    fontWeight: 400
  },
  header: {
    fontSize: 14,
    borderRadius: 18,
    backgroundColor: "transparent",
    height: "auto",
    display: "flex",
    alignItems: "center",
    gap: e.spacing(2),
    padding: e.spacing(1, 8),
    color: e.palette.text.secondary
  },
  headerCompact: {
    padding: 0,
    minHeight: 50
  },
  column: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    wordBreak: "break-word"
  },
  addInfoBtnColumn: {
    justifyContent: "flex-end"
  },
  rowWrap: {
    display: "flex",
    flexDirection: "column",
    marginTop: e.spacing(3),
    padding: e.spacing(5.5, 8),
    borderRadius: 18,
    backgroundColor: e.palette.background.paper,
    color: e.palette.text.primary
  },
  rowWithAction: {
    transitionProperty: "box-shadow",
    transitionDuration: `${e.transitions.duration.standard}ms`,
    transitionTimingFunction: e.transitions.easing.easeInOut,
    cursor: "pointer",
    boxShadow: "0 0 0 transparent",
    color: e.palette.text.primary,
    "&:hover": {
      boxShadow: `0 2px 5px ${_(e.palette.grey[400], 0.2)}`
    }
  },
  rowList: {
    fontSize: 14
  },
  row: {
    minHeight: 50,
    display: "flex",
    alignItems: "center",
    gap: e.spacing(2)
  },
  rowCompact: {
    margin: 0,
    padding: 0,
    borderRadius: 0,
    minHeight: "auto",
    borderTop: "1px solid",
    borderColor: e.palette.divider,
    backgroundColor: "transparent"
  },
  chevron: {
    transition: "rotate 0.3s"
  },
  chevronRotate: {
    rotate: "180deg"
  },
  cardList: {},
  card: {
    display: "flex",
    flexDirection: "column",
    padding: e.spacing(4),
    borderRadius: 12,
    border: "1px solid",
    borderColor: e.palette.grey[200],
    backgroundColor: e.palette.background.paper,
    marginBottom: e.spacing(4)
  },
  cardBody: {
    display: "flex",
    flexDirection: "column",
    gap: e.spacing(4)
  },
  cardRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: e.spacing(2)
  },
  cardLeft: {
    color: e.palette.text.disabled
  },
  cardRight: {
    textAlign: "right",
    wordBreak: "break-word"
  }
})), xn = C()((e) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 200,
    padding: e.spacing(10),
    textAlign: "center"
  }
}));
function we({ className: e, text: t }) {
  const { classes: r, cx: a } = xn();
  return /* @__PURE__ */ n(me, { className: a(r.root, e), children: t || B("common.no-data") });
}
const Ne = C()((e) => ({
  centered: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 200,
    padding: e.spacing(10),
    textAlign: "center"
  },
  absolute: {
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
  }
}));
function bn({ size: e, className: t }) {
  return /* @__PURE__ */ n(ee, { size: e, className: t });
}
function pt({ size: e, className: t }) {
  const { classes: r, cx: a } = Ne();
  return /* @__PURE__ */ n(ee, { size: e, className: a(r.absolute, t) });
}
function Cn({
  size: e,
  className: t,
  ...r
}) {
  const { classes: a, cx: o } = Ne();
  return /* @__PURE__ */ n(
    d,
    {
      display: "flex",
      justifyContent: "center",
      className: o(a.centered, t),
      ...r,
      children: /* @__PURE__ */ n(ee, { size: e })
    }
  );
}
function wn({
  item: e,
  columns: t,
  AdditionalInfoComponent: r,
  addInfoBtnText: a
}) {
  const { classes: o, cx: i } = re(), [s, c] = G(!1), g = () => {
    c((l) => !l);
  };
  return /* @__PURE__ */ m(
    d,
    {
      className: i(
        o.card,
        (e.onRowClick || e.rowLink) && o.rowWithAction
      ),
      onClick: e.onRowClick,
      component: e.rowLink ? te : "div",
      to: e.rowLink,
      children: [
        /* @__PURE__ */ m(d, { className: o.cardBody, children: [
          t.map((l) => !l.header && !l.renderCell(e) ? null : /* @__PURE__ */ m(d, { className: o.cardRow, children: [
            /* @__PURE__ */ n(d, { className: o.cardLeft, children: l.header }),
            /* @__PURE__ */ n(d, { className: i(o.cardRight, l.cellClassName), children: l.renderCell(e) })
          ] }, l.id)),
          !!r && /* @__PURE__ */ n(d, { className: o.cardRow, children: /* @__PURE__ */ n(
            $,
            {
              sx: { margin: "0 auto" },
              variant: "outlined",
              onClick: g,
              size: "small",
              endIcon: /* @__PURE__ */ n(
                Ce,
                {
                  className: i(
                    o.chevron,
                    s && o.chevronRotate
                  )
                }
              ),
              children: a
            }
          ) })
        ] }),
        !!r && /* @__PURE__ */ n(fe, { in: s, children: /* @__PURE__ */ n(r, { item: e }) })
      ]
    }
  );
}
const Nn = ne(
  wn,
  (e, t) => be(t.item, e.item)
);
function kn({
  item: e,
  columns: t,
  compactView: r,
  AdditionalInfoComponent: a,
  addInfoBtnColumnClassName: o,
  addInfoBtnText: i
}) {
  const { classes: s, cx: c } = re(), [g, l] = G(!1), f = () => {
    l((p) => !p);
  };
  return /* @__PURE__ */ m(
    d,
    {
      className: c(
        s.rowWrap,
        r && s.rowCompact,
        (e.onRowClick || e.rowLink) && s.rowWithAction
      ),
      onClick: e.onRowClick,
      component: e.rowLink ? te : "div",
      to: e.rowLink,
      children: [
        /* @__PURE__ */ m(d, { className: s.row, children: [
          t.map((p) => p.renderCell(e) ? /* @__PURE__ */ n(
            d,
            {
              className: c(
                s.column,
                p.className,
                p.cellClassName
              ),
              children: p.renderCell(e)
            },
            p.id
          ) : null),
          !!a && /* @__PURE__ */ n(
            d,
            {
              className: c(
                s.column,
                s.addInfoBtnColumn,
                o
              ),
              children: /* @__PURE__ */ n(
                $,
                {
                  variant: "outlined",
                  onClick: f,
                  endIcon: /* @__PURE__ */ n(
                    Ce,
                    {
                      className: c(
                        s.chevron,
                        g && s.chevronRotate
                      )
                    }
                  ),
                  children: i
                }
              )
            }
          )
        ] }),
        !!a && /* @__PURE__ */ n(fe, { in: g, children: /* @__PURE__ */ n(a, { item: e }) })
      ]
    }
  );
}
const vn = ne(
  kn,
  (e, t) => be(t.item, e.item)
);
function ut({
  items: e,
  columns: t,
  className: r,
  isLoading: a,
  compactView: o,
  CardComponent: i = Nn,
  AdditionalInfoComponent: s,
  addInfoBtnColumnClassName: c,
  addInfoBtnText: g = B("common.show-details"),
  hideEmptyPlaceholder: l,
  getKey: f,
  isBreakpoint: p = Ve()
}) {
  const { classes: u, cx: y } = re();
  return e && !e.length && !a ? l ? null : /* @__PURE__ */ n(we, {}) : a ? /* @__PURE__ */ n(d, { className: y(u.root, r), children: /* @__PURE__ */ n(Cn, {}) }) : /* @__PURE__ */ n(d, { className: y(u.root, r), children: p ? /* @__PURE__ */ n(d, { className: u.cardList, children: e.map((b) => /* @__PURE__ */ n(
    i,
    {
      item: b,
      columns: t,
      AdditionalInfoComponent: s,
      addInfoBtnText: g
    },
    f(b)
  )) }) : /* @__PURE__ */ m(Z, { children: [
    /* @__PURE__ */ n(
      d,
      {
        className: y(u.header, o && u.headerCompact),
        children: t.map((b) => /* @__PURE__ */ n(
          yn,
          {
            column: b,
            className: y(u.column, b.className)
          },
          b.id
        ))
      }
    ),
    /* @__PURE__ */ n(d, { className: u.rowList, children: e.map((b) => /* @__PURE__ */ n(
      vn,
      {
        item: b,
        columns: t,
        compactView: o,
        AdditionalInfoComponent: s,
        addInfoBtnColumnClassName: c,
        addInfoBtnText: g
      },
      f(b)
    )) })
  ] }) });
}
const Sn = C()((e) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    paddingLeft: e.spacing(3),
    paddingRight: e.spacing(3),
    [e.breakpoints.down("sm")]: {
      minHeight: "100%",
      flexGrow: 1,
      paddingLeft: e.spacing(2),
      paddingRight: e.spacing(2)
    }
  },
  card: {
    width: 680,
    maxWidth: "100%",
    padding: e.spacing(10),
    [e.breakpoints.down("sm")]: {
      padding: e.spacing(5),
      width: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      minHeight: "100%",
      flexGrow: 1
    }
  },
  headerWrap: {
    display: "flex",
    flexDirection: "column",
    gap: e.spacing(3),
    marginBottom: e.spacing(10)
  },
  header: {
    display: "flex",
    gap: e.spacing(3),
    justifyContent: "space-between"
  },
  headerTitle: {
    display: "flex",
    gap: e.spacing(2),
    alignItems: "center"
  },
  subtitle: {
    color: e.palette.text.secondary
  },
  content: {
    [e.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "stretch",
      flexGrow: 1
    }
  }
}));
function gt({
  title: e,
  children: t,
  subtitle: r,
  rootClass: a,
  cardClass: o,
  contentClass: i,
  headerIcon: s,
  hideCloseButton: c,
  titleVariant: g = "h5"
}) {
  const { classes: l, cx: f } = Sn(), p = nn(), u = I(() => {
    window.history.state.idx > 1 ? p(-1) : p("/");
  }, [p]);
  return /* @__PURE__ */ n(d, { className: f(l.root, a), children: /* @__PURE__ */ m(he, { className: f(l.card, o), children: [
    /* @__PURE__ */ m(d, { className: l.headerWrap, children: [
      /* @__PURE__ */ m(d, { className: l.header, children: [
        /* @__PURE__ */ m(d, { className: l.headerTitle, children: [
          s && s,
          /* @__PURE__ */ n(W, { variant: g, children: e })
        ] }),
        !c && /* @__PURE__ */ n(O, { onClick: u, children: /* @__PURE__ */ n(V, { sx: { color: "inherit" } }) })
      ] }),
      r && /* @__PURE__ */ n(W, { variant: "body2", className: l.subtitle, children: r })
    ] }),
    /* @__PURE__ */ n(d, { className: f(l.content, i), children: t })
  ] }) });
}
const Bn = C()((e) => ({
  root: {
    marginTop: e.spacing(-2),
    marginBottom: e.spacing(-2),
    fontSize: "inherit",
    color: e.palette.text.secondary
  },
  copiedTooltip: {
    color: e.palette.success.main
  },
  icon: {
    fontSize: "inherit",
    width: "1em",
    height: "1em"
  },
  copyIcon: {},
  doneIcon: {
    "&&": {
      color: e.palette.success.main
    }
  }
})), In = 2e3;
function mt({
  text: e,
  className: t,
  disabled: r,
  color: a = "primary",
  size: o = "medium",
  tooltipPlacement: i = "bottom",
  renderButton: s
}) {
  const { classes: c, cx: g } = Bn(), [l, f] = G(!1);
  if (Q(() => {
    l && setTimeout(() => {
      f(!1), document.activeElement?.blur();
    }, In);
  }, [l]), !e)
    return null;
  function p(u) {
    return /* @__PURE__ */ n(
      O,
      {
        disabled: r,
        color: a,
        size: o,
        className: g(c.root, t),
        children: u ? /* @__PURE__ */ n(
          ze,
          {
            className: g(c.icon, c.doneIcon),
            sx: { color: "inherit" }
          }
        ) : /* @__PURE__ */ n(
          Me,
          {
            className: g(c.icon, c.copyIcon),
            sx: { color: "inherit" }
          }
        )
      }
    );
  }
  return /* @__PURE__ */ n(tn, { text: e, onCopy: () => f(!0), children: /* @__PURE__ */ n(
    Qe,
    {
      title: l ? /* @__PURE__ */ n("span", { className: c.copiedTooltip, children: B("common.copied") }) : B("common.copy-to-clipboard"),
      enterNextDelay: 0,
      placement: i,
      children: s ? s(l) : p(l)
    }
  ) });
}
const Ln = C()((e) => ({
  endAdornment: {
    gap: e.spacing(1)
  },
  adornmentPreview: {
    width: 20,
    height: 20,
    borderRadius: 50,
    border: `1px solid ${e.palette.divider}`
  },
  paper: {
    backgroundColor: e.palette.background.paper,
    padding: e.spacing(2),
    borderRadius: 12,
    boxShadow: `0px 1px 5px 0px ${_(e.palette.text.primary, 0.14)}, 0px 1px 8px 0px ${_(e.palette.text.primary, 0.12)}`
  },
  colorPicker: {
    // The '!important' flag is required here because react-best-gradient-color-picker uses inline css in the tags
    backgroundColor: `${e.palette.background.paper} !important`
  }
}));
function Rn({
  wrapperClassName: e,
  value: t = "",
  solidOnly: r,
  gradientOnly: a,
  id: o,
  InputProps: i,
  hideColorTypeBtns: s,
  onChange: c,
  ...g
}, l) {
  const { classes: f } = Ln(), p = Ue(), u = F(
    () => o ?? `gradientColorPickerField_${p}`,
    [o, p]
  ), [y, b] = G(null), P = !!y, N = (S) => {
    b(S.currentTarget);
  }, R = () => {
    b(null);
  }, T = xe(), [w, j] = G(t), { setSolid: x, setGradient: E } = on(w, j);
  Q(() => {
    r && x(w);
  }, [w, x, r]), Q(() => {
    a && E(w);
  }, [w, E, a]);
  const v = I(
    (S) => {
      j(S ?? ""), c?.(S ?? "");
    },
    [c]
  );
  return /* @__PURE__ */ m(d, { className: e, ref: l, children: [
    /* @__PURE__ */ n(
      ge,
      {
        ...g,
        id: u,
        "aria-describedby": u,
        value: w,
        onClick: N,
        focused: P,
        InputProps: {
          ...i,
          readOnly: !0,
          endAdornment: w && /* @__PURE__ */ m(ye, { position: "end", className: f.endAdornment, children: [
            /* @__PURE__ */ n(
              d,
              {
                className: f.adornmentPreview,
                style: { background: w }
              }
            ),
            /* @__PURE__ */ n(O, { onClick: () => v(""), size: "small", children: /* @__PURE__ */ n(V, {}) })
          ] })
        }
      }
    ),
    /* @__PURE__ */ n(
      Oe,
      {
        id: u,
        open: P,
        anchorEl: y,
        onClose: R,
        classes: {
          paper: f.paper
        },
        elevation: 1,
        anchorOrigin: {
          vertical: "top",
          horizontal: "left"
        },
        transformOrigin: {
          vertical: "bottom",
          horizontal: "left"
        },
        children: /* @__PURE__ */ n(
          rn,
          {
            ...g,
            className: f.colorPicker,
            disableDarkMode: T !== "dark",
            value: w,
            onChange: v,
            hideColorTypeBtns: (r || a) ?? s,
            hidePresets: !0
          }
        )
      }
    )
  ] });
}
const ft = q(Rn), En = C()(
  (e, { color: t = e.palette.primary.main }) => ({
    root: {
      position: "relative",
      fontSize: 14,
      paddingLeft: e.spacing(2),
      [e.breakpoints.down("sm")]: {
        fontSize: 12
      },
      "&::before": {
        display: "block",
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        borderRadius: 3,
        width: 3,
        backgroundColor: t
      }
    },
    withMarginBottom: {
      marginBottom: e.spacing(5)
    }
  })
);
function ht({
  children: e,
  className: t,
  withMarginBottom: r,
  color: a,
  component: o = "div"
}) {
  const { classes: i, cx: s } = En({ color: a });
  return /* @__PURE__ */ n(
    d,
    {
      className: s(
        i.root,
        t,
        r && i.withMarginBottom
      ),
      component: o,
      children: e
    }
  );
}
const Dn = C()((e) => ({
  root: {
    display: "block",
    padding: e.spacing(5),
    borderStyle: "solid",
    borderWidth: 2,
    borderColor: e.palette.divider,
    borderRadius: 16,
    transitionProperty: "border-color",
    transitionDuration: `${e.transitions.duration.short}ms`,
    userSelect: "none",
    WebkitUserSelect: "none",
    "label&": {
      cursor: "pointer",
      "&:hover": {
        borderColor: _(e.palette.primary.main, 0.5)
      }
    },
    "div&": {
      cursor: "default"
    }
  },
  active: {
    "&, &&:hover": {
      borderColor: e.palette.primary.main
    }
  }
}));
function yt({
  children: e,
  active: t,
  className: r,
  component: a = "label",
  htmlFor: o,
  onClick: i
}) {
  const { classes: s, cx: c } = Dn();
  return /* @__PURE__ */ n(
    d,
    {
      className: c(s.root, r, t && s.active),
      component: a,
      htmlFor: o,
      onClick: i,
      children: e
    }
  );
}
const ke = C()((e) => ({
  root: {
    "&&": {
      left: e.spacing(3),
      right: e.spacing(3),
      bottom: e.spacing(3),
      width: "auto",
      maxWidth: "var(--toastify-toast-width)"
    }
  },
  toast: {
    "&&": {
      backgroundColor: _(e.palette.grey[400], 0.8),
      backdropFilter: "blur(16px)",
      borderRadius: 12,
      cursor: "default",
      marginBottom: 0,
      "& + &": {
        marginTop: e.spacing(2)
      }
    }
  },
  toastBody: {
    wordBreak: "break-word"
  },
  content: {
    color: e.palette.text.primary
  },
  date: {
    color: e.palette.text.disabled,
    marginBottom: e.spacing(2),
    fontSize: 14
  },
  title: {
    fontWeight: 700,
    marginBottom: e.spacing(2)
  },
  message: {
    fontSize: 14
  },
  readMoreLink: {
    display: "inline-block",
    marginTop: e.spacing(2),
    color: e.palette.primary.main,
    fontSize: 14
  }
}));
function Wn({
  key: e,
  message: t,
  type: r,
  date: a,
  withoutTitle: o,
  title: i,
  readMoreLink: s
}) {
  const { classes: c } = ke();
  return /* @__PURE__ */ m("div", { className: c.content, children: [
    !!a && /* @__PURE__ */ n("div", { className: c.date, children: a }),
    !o && /* @__PURE__ */ n("div", { className: c.title, children: i || (r !== "default" ? B(`alert.${r}`) : "") }),
    /* @__PURE__ */ n("div", { className: c.message, children: t }),
    !!s && /* @__PURE__ */ n(
      "a",
      {
        className: c.readMoreLink,
        href: s,
        rel: "noopener noreferrer",
        target: "_blank",
        children: B("common.read-more")
      }
    )
  ] }, e);
}
const Pn = ({
  key: e,
  message: t,
  type: r = "default",
  date: a,
  withoutTitle: o = !1,
  title: i,
  autoClose: s = 7e3,
  closeOnClick: c = !0,
  readMoreLink: g
}) => {
  an(
    /* @__PURE__ */ n(
      Wn,
      {
        message: t,
        type: r,
        date: a,
        withoutTitle: o,
        title: i,
        readMoreLink: g
      },
      e
    ),
    {
      type: r,
      autoClose: s,
      closeOnClick: c
    }
  );
};
function xt() {
  const { classes: e } = ke(), t = xe();
  return Q(() => {
    cn();
  }, []), /* @__PURE__ */ n(qe, { children: /* @__PURE__ */ n(
    sn,
    {
      className: e.root,
      position: "bottom-left",
      theme: t,
      newestOnTop: !0,
      toastClassName: e.toast,
      bodyClassName: e.toastBody
    }
  ) });
}
function bt({
  imgUrl: e,
  img2xUrl: t,
  img3xUrl: r,
  altText: a = "",
  className: o
}) {
  let i = `${e} 1x`;
  return t && (i += `,${t} 2x`), r && (i += `,${r} 3x`), /* @__PURE__ */ n(
    "img",
    {
      className: o,
      alt: a,
      src: e,
      srcSet: i
    }
  );
}
const Tn = C()((e, t, r) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    justifyContent: "space-evenly",
    width: 36,
    height: 36,
    minWidth: 0,
    transitionTimingFunction: "step-end",
    backgroundColor: "transparent",
    border: 0,
    "&:hover, &&": {
      backgroundColor: "transparent",
      outline: "none"
    }
  },
  active: {
    transitionDuration: "0s",
    [`& .${r.lineTop}`]: {
      transform: "translateY(4px) rotate(45deg)",
      marginTop: 5
    },
    [`& .${r.lineMiddle}`]: {
      opacity: 0
    },
    [`& .${r.lineBottom}`]: {
      transform: "translateY(-3px) rotate(-45deg)",
      marginBottom: 5
    }
  },
  line: {
    width: 18,
    height: 3,
    backgroundColor: e.palette.primary.main,
    borderRadius: 2,
    transition: "transform 0.2s, opacity 0.2s, margin 0.2s",
    transformOrigin: "center"
  },
  lineTop: {},
  lineMiddle: {},
  lineBottom: {}
})), Ct = q(
  ({ className: e, isActive: t, ...r }, a) => {
    const { classes: o, cx: i } = Tn();
    return /* @__PURE__ */ m(
      O,
      {
        className: i(o.root, t && o.active, e),
        ref: a,
        variant: "text",
        "aria-label": "open/close",
        color: "primary",
        ...r,
        children: [
          /* @__PURE__ */ n("i", { className: i(o.line, o.lineTop) }),
          /* @__PURE__ */ n("i", { className: i(o.line, o.lineMiddle) }),
          /* @__PURE__ */ n("i", { className: i(o.line, o.lineBottom) })
        ]
      }
    );
  }
);
function An({ error: e }) {
  return /* @__PURE__ */ n(me, { variant: "outlined", square: !0, children: `Error status: ${e.status}` });
}
function Fn(e) {
  return e.find((t) => t.isLoading);
}
function $n(e) {
  return e.find((t) => t.error);
}
function jn(e) {
  return e ? e instanceof Array && e.length === 0 : !0;
}
function zn(e) {
  return e.every((t) => jn(t.data));
}
function wt({
  queries: e,
  children: t,
  LoadingComponent: r = bn,
  EmptyComponent: a = we
}) {
  if (Fn(e))
    return /* @__PURE__ */ n(r, {});
  if (!e)
    return null;
  const o = $n(e);
  return o ? /* @__PURE__ */ n(An, { error: o.error }) : zn(e) ? /* @__PURE__ */ n(a, {}) : /* @__PURE__ */ n(Z, { children: t(...e) });
}
const Mn = C()((e) => ({
  wrapper: {
    marginTop: e.spacing(20),
    paddingBottom: e.spacing(30),
    [e.breakpoints.down("sm")]: {
      marginTop: e.spacing(15)
    }
  },
  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: e.spacing(9, 10),
    minHeight: 480,
    [e.breakpoints.down("lg")]: {
      minHeight: 460
    },
    [e.breakpoints.down("md")]: {
      minHeight: 420
    },
    [e.breakpoints.down("sm")]: {
      minHeight: 400,
      padding: e.spacing(9, 6)
    }
  },
  title: {
    fontWeight: 700,
    lineHeight: 0.75,
    fontSize: 120,
    color: e.palette.grey[400],
    marginBottom: e.spacing(5),
    [e.breakpoints.down("sm")]: {
      fontSize: 96
    }
  },
  hint: {
    marginBottom: e.spacing(10)
  }
}));
function Nt() {
  const { classes: e } = Mn();
  return /* @__PURE__ */ n(d, { className: e.wrapper, children: /* @__PURE__ */ n(Xe, { children: /* @__PURE__ */ m(he, { className: e.card, children: [
    /* @__PURE__ */ n(d, { className: e.title, children: B("page-not-found.title") }),
    /* @__PURE__ */ n(d, { className: e.hint, children: B("page-not-found.hint") }),
    /* @__PURE__ */ n($, { component: te, to: "/", children: B("page-not-found.btn") })
  ] }) }) });
}
function Hn({
  label: e,
  endLabel: t,
  disabled: r
}) {
  return /* @__PURE__ */ m(
    d,
    {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 2,
      children: [
        e && /* @__PURE__ */ n(
          W,
          {
            variant: "subtitle2",
            component: "div",
            sx: (a) => ({
              color: a.palette.grey[r ? 400 : 900]
            }),
            children: e
          }
        ),
        t && /* @__PURE__ */ n(
          W,
          {
            variant: "body3",
            component: "div",
            sx: (a) => ({
              color: a.palette.grey[r ? 400 : 600],
              textAlign: "right",
              width: e ? "auto" : "100%"
            }),
            children: t
          }
        )
      ]
    }
  );
}
const _n = C()((e) => ({
  root: {},
  placeholder: {
    "&&": {
      opacity: 0.8
    }
  },
  item: {
    justifyContent: "space-between",
    alignItems: "center",
    gap: e.spacing(2)
  },
  itemContent: {
    display: "inline-flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: e.spacing(2),
    overflow: "hidden",
    "& > img, & > svg": {
      width: 24,
      height: "auto"
    }
  },
  itemPlaceholder: {
    color: e.palette.grey[600]
  }
})), kt = q(function({
  value: t = "",
  label: r,
  endLabel: a,
  disabled: o,
  helperText: i,
  errorText: s,
  sx: c,
  style: g,
  className: l,
  selectStyleProps: f,
  placeholder: p,
  showPlaceholderInList: u,
  options: y,
  ...b
}, P) {
  const { classes: N, cx: R } = _n(), T = I(
    (x) => {
      const E = y.find((v) => v.value === x);
      return /* @__PURE__ */ n(
        "span",
        {
          className: R(
            N.itemContent,
            !E && N.itemPlaceholder
          ),
          children: E ? E.label : p
        }
      );
    },
    [N.itemContent, N.itemPlaceholder, R, y, p]
  ), w = F(() => {
    if (y && y.length)
      return y.map((x) => x.label ? x.isSubheader ? /* @__PURE__ */ n(Ye, { children: x.label }, `selectBoxItem_${x.label}${x.value}`) : /* @__PURE__ */ n(
        le,
        {
          value: x.value,
          disabled: x.disabled,
          children: /* @__PURE__ */ n("span", { className: N.itemContent, children: x.label })
        },
        `selectBoxItem_${x.label}${x.value}`
      ) : null);
  }, [N.itemContent, y]);
  return /* @__PURE__ */ m(d, { sx: c, className: l, style: g, ref: P, children: [
    !!(r || a) && /* @__PURE__ */ n(Je, { id: b.id, children: /* @__PURE__ */ n(Hn, { label: r, endLabel: a, disabled: o }) }),
    /* @__PURE__ */ m(
      Ke,
      {
        label: r,
        sx: { width: "100%", padding: 0 },
        value: t,
        renderValue: () => T(t),
        disabled: o,
        displayEmpty: !!p,
        error: !!s,
        ...f,
        ...b,
        children: [
          !!u && !!p && /* @__PURE__ */ n(le, { className: N.placeholder, value: "", disabled: !0, children: /* @__PURE__ */ n("span", { children: p }) }),
          w
        ]
      }
    ),
    !!s && /* @__PURE__ */ n(U, { error: !0, children: s }),
    i && /* @__PURE__ */ n(U, { children: i })
  ] });
}), Gn = (e) => /* @__PURE__ */ L.createElement("svg", { width: 10, height: 2, viewBox: "0 0 10 2", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ L.createElement("rect", { width: 10, height: 2, rx: 1, fill: "currentColor" })), Qn = (e) => /* @__PURE__ */ L.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ L.createElement("rect", { x: 4, width: 2, height: 10, rx: 1, fill: "currentColor" }), /* @__PURE__ */ L.createElement("rect", { y: 4, width: 10, height: 2, rx: 1, fill: "currentColor" })), On = C()((e) => ({
  wrap: {},
  labelBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    flexWrap: "wrap"
  },
  input: {},
  controlButtons: {
    display: "flex",
    gap: e.spacing(1),
    alignItems: "center"
  },
  controlButton: {
    fontWeight: 400,
    fontSize: 12,
    height: 24,
    minHeight: "auto",
    minWidth: "auto"
  },
  stepButton: {
    padding: 0,
    width: 24,
    height: 24
  },
  maxButton: {
    paddingLeft: e.spacing(2),
    paddingRight: e.spacing(2)
  }
})), ue = (e, t) => t ? pn.isBigNumber(e) ? e.toFixed() : e : e ? Number(e) : null, qn = ({
  name: e,
  value: t,
  locale: r = "en-US",
  label: a,
  id: o,
  thousandSeparator: i,
  decimalSeparator: s,
  withStepButtons: c = !1,
  withMaxButton: g = !1,
  maxButtonValue: l,
  step: f = 1,
  errorText: p,
  helperText: u,
  helperTextClass: y,
  wrapperClassName: b,
  className: P,
  decimalScale: N,
  inputType: R = "text",
  inputMode: T = ln ? N === 0 ? "numeric" : "text" : "decimal",
  allowLeadingZeros: w = !1,
  autoFocus: j = !1,
  allowNegative: x = !0,
  maxLength: E,
  minValue: v = Number.MIN_SAFE_INTEGER,
  maxValue: S = Number.MAX_SAFE_INTEGER,
  disabled: ve = !1,
  isNumericString: Se = !0,
  fixedDecimalScale: Be = !1,
  enterKeyHint: oe = "done",
  submitByEnter: ae = !1,
  placeholder: Ie,
  tabIndex: Le = 0,
  prefix: Re = "",
  suffix: Ee = "",
  variant: De,
  onChange: ie,
  isStringValue: z,
  ...We
}, Pe) => {
  const { classes: k, cx: D } = On(), Te = F(
    () => o ?? `numberField_${e}${R}`,
    [o, e]
  ), Ae = F(() => {
    switch (r) {
      case "zh-CN":
        return "wan";
      default:
        return "thousand";
    }
  }, [r]);
  Q(() => {
    t !== M.current && (M.current = ue(t, z));
  }, [t, z]);
  const X = I(
    (h) => !(h && ((v || v === 0) && h < v || !x && h < 0 || (S || S === 0) && h > S)),
    [v, S, x]
  ), M = Ze(ue(t, z)), A = I(
    (h) => {
      M.current = h, ie?.(h);
    },
    [ie]
  ), Fe = I(
    (h) => {
      const J = z ? h.value : h.floatValue;
      A(J);
    },
    [A, z]
  ), Y = I(
    (h = !1) => {
      const J = h ? -1 : 1;
      let K = +(M.current ?? 0) + f * J;
      X(K) || (K = h ? v : S), A(K);
    },
    [X, S, v, A, f]
  ), se = F(() => /* @__PURE__ */ m(Z, { children: [
    /* @__PURE__ */ n(
      $,
      {
        onClick: () => Y(!0),
        size: "small",
        className: D(k.controlButton, k.stepButton),
        children: /* @__PURE__ */ n(Gn, {})
      }
    ),
    /* @__PURE__ */ n(
      $,
      {
        onClick: () => Y(!1),
        size: "small",
        className: D(k.controlButton, k.stepButton),
        children: /* @__PURE__ */ n(Qn, {})
      }
    )
  ] }), [D, k, Y]), ce = F(() => /* @__PURE__ */ n(
    $,
    {
      onClick: () => A(l?.toFixed()),
      className: D(k.controlButton, k.maxButton),
      size: "small",
      children: B("common.max")
    }
  ), [D, k, l, A]), $e = I(
    (h) => /* @__PURE__ */ n(
      ge,
      {
        ...h,
        InputProps: {
          endAdornment: (c || g) && /* @__PURE__ */ n(ye, { position: "end", children: /* @__PURE__ */ m(d, { className: k.controlButtons, children: [
            c && se,
            g && ce
          ] }) })
        },
        inputProps: {
          ...h.inputProps,
          autoComplete: "off",
          enterKeyHint: oe,
          inputMode: T,
          step: f
        }
      }
    ),
    [
      ce,
      se,
      k.controlButtons,
      oe,
      f,
      g,
      c
    ]
  ), je = I(
    (h) => {
      !ae && h.key === "Enter" && h.preventDefault();
    },
    [ae]
  );
  return /* @__PURE__ */ m(d, { className: D(k.wrap, b), ref: Pe, children: [
    /* @__PURE__ */ n(
      dn,
      {
        label: a,
        error: !!p,
        customInput: $e,
        id: Te,
        value: M.current,
        name: e,
        displayType: "input",
        allowNegative: x,
        allowLeadingZeros: w,
        variant: De,
        className: D(k.input, P),
        type: R,
        autoFocus: j,
        disabled: ve,
        decimalSeparator: s ?? de(r, "decimal"),
        thousandSeparator: i ?? de(r),
        thousandsGroupStyle: Ae,
        decimalScale: N,
        fixedDecimalScale: Be,
        isNumericString: Se,
        placeholder: Ie,
        inputMode: T,
        onValueChange: Fe,
        tabIndex: Le,
        prefix: Re,
        suffix: Ee,
        isAllowed: ({ floatValue: h }) => X(h),
        onKeyPress: je,
        allowedDecimalSeparators: [",", "."],
        ...We
      }
    ),
    (!!u || !!p) && /* @__PURE__ */ n(U, { error: !!p, className: y, children: p ?? u })
  ] });
}, vt = q(qn), St = un({
  onNotification({ error: e, onError: t }) {
    const r = typeof t == "function" ? t(e) : en(e);
    Pn({
      title: B("error.error"),
      message: r,
      type: "error"
    });
  }
});
export {
  ut as AppList,
  dt as AppModal,
  gt as CardDialog,
  mt as CopyButton,
  ft as GradientColorPicker,
  bt as ImageX,
  ht as InfoHelperBlock,
  yt as LabelWrap,
  xt as Notifications,
  vt as NumberFormatField,
  Nt as PageNotFound,
  wt as Queries,
  we as QueryEmpty,
  An as QueryError,
  bn as QueryLoading,
  pt as QueryLoadingAbsolute,
  Cn as QueryLoadingCentered,
  kt as SelectBox,
  H as SortDirection,
  Ct as ToggleIcon,
  Pn as notification,
  St as queryFnNotifyWrapper
};
//# sourceMappingURL=index.js.map
